import { FormControl } from '@angular/forms';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';

export class VariaveisDisponiveisDialogData {
    variaveis: VariavelStruct[];
    targetControl?: FormControl;
    /** Posição do cursor no campo de destino. */
    cursorStart?: number | null;
    cursorEnd?: number | null;
    /** Callback opcional usado para inserir a variável no editor de origem. */
    onInsert?: (variavel: VariavelStruct) => void;
}
